/**
 * Utility functions for birthday voucher modal
 */
import { DEFAULT_BIRTHDAY_VOUCHER_DISPLAY_DAYS } from '../constants';
export var BIRTHDAY_VOUCHER_MODAL_COOKIE = 'zl_birthday_voucher_modal_shown';
export var BIRTHDAY_VOUCHER_BANNER_COOKIE = 'zl_birthday_voucher_banner_shown';
/**
 * Check if today is within the birthday week (birthday + 6 days after)
 * @param birthdayTimestamp - Birthday timestamp in milliseconds
 * @param showForDays - Number of days to show the modal after birthday (default: DEFAULT_BIRTHDAY_VOUCHER_DISPLAY_DAYS :7)
 * @returns boolean - true if today is within the birthday period
 */
export var isWithinBirthdayPeriod = function (birthdayTimestamp, showForDays) {
    if (showForDays === void 0) { showForDays = DEFAULT_BIRTHDAY_VOUCHER_DISPLAY_DAYS; }
    if (!birthdayTimestamp) {
        return false;
    }
    var now = new Date();
    var birthday = new Date(birthdayTimestamp);
    // Get current year's birthday
    var currentYearBirthday = new Date(now.getFullYear(), birthday.getMonth(), birthday.getDate());
    // Calculate the difference in days
    var timeDiff = now.getTime() - currentYearBirthday.getTime();
    var daysDiff = Math.floor(timeDiff / (1000 * 3600 * 24));
    // Check if today is within the birthday period (birthday to birthday + showForDays)
    return daysDiff >= 0 && daysDiff < showForDays;
};
/**
 * Check if it's the user's actual birthday today
 * @param birthdayTimestamp - Birthday timestamp in milliseconds
 * @returns boolean - true if today is the exact birthday
 */
export var isTodayBirthday = function (birthdayTimestamp) {
    if (!birthdayTimestamp) {
        return false;
    }
    var now = new Date();
    var birthday = new Date(birthdayTimestamp);
    return now.getDate() === birthday.getDate() && now.getMonth() === birthday.getMonth();
};
/**
 * Get the birthday year for display
 * @param birthdayTimestamp - Birthday timestamp in milliseconds
 * @returns Birth year or 0 if invalid
 */
export var getBirthYear = function (birthdayTimestamp) {
    if (!birthdayTimestamp || isNaN(birthdayTimestamp)) {
        console.warn("[getBirthYear] Invalid birthday timestamp: ".concat(birthdayTimestamp));
        return 0;
    }
    return new Date(birthdayTimestamp).getFullYear();
};
/**
 * Calculate user's age
 * @param birthdayTimestamp - Birthday timestamp in milliseconds
 * @returns User's age or 0 if invalid
 */
export var calculateAge = function (birthdayTimestamp) {
    if (!birthdayTimestamp || isNaN(birthdayTimestamp)) {
        console.warn("[calculateAge] Invalid birthday timestamp: ".concat(birthdayTimestamp));
        return 0;
    }
    var now = new Date();
    var birthday = new Date(birthdayTimestamp);
    var age = now.getFullYear() - birthday.getFullYear();
    var monthDiff = now.getMonth() - birthday.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < birthday.getDate())) {
        age--;
    }
    return age;
};
/**
 * Format ISO date string to MM/DD/YYYY format
 * @param isoDate - ISO date string (e.g., "2024-12-31T23:59:59.000Z")
 * @returns Formatted date string or empty string if invalid
 */
export var formatISODateToMMDDYYYY = function (isoDate) {
    var date = new Date(isoDate);
    // Validate date
    if (isNaN(date.getTime())) {
        console.warn("[formatISODateToMMDDYYYY] Invalid date string: \"".concat(isoDate, "\""));
        return '';
    }
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var day = String(date.getDate()).padStart(2, '0');
    var year = date.getFullYear();
    return "".concat(month, "/").concat(day, "/").concat(year);
};
